<template>
  <div>
    <breadcrumb class="pl-2 mt-2" />

    <ProtagonistList :type="this.$route.name" :posts="posts" />
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import Breadcrumb from "@/components/General/Breadcrumb";
import ProtagonistList from "@/components/Posts/ProtagonistList";

export default {
  components: {
    Breadcrumb,
    ProtagonistList
  },
  data() {
    return {
      posts: []
    }
  },
  computed: {
    ...mapState("user", ["current_user"])
  },
  mounted() {
    window.scrollTo(0, 0);

  },
  created() {
    this.getProtagonists()
  },
  methods: {
    ...mapActions("protagonists", ["fetchProtagonists"]),
    async getProtagonists() {
      if (!localStorage.getItem("view_as"))
        this.posts = await this.fetchProtagonists(null, this.$route.name);
      else
        this.posts = await this.fetchProtagonists(this.current_user.full_legal_number,this.$route.name)
    }
  }
};
</script>
<style lang="css">
@media screen and (min-width: 300px) and (max-width: 425px) {
  .select-category > .v-text-field.v-text-field--enclosed .v-text-field__details, 
  .select-category > .v-text-field.v-text-field--enclosed > .v-input__control > .v-input__slot {
    margin: 0;
    max-height: 38px;
    min-height: 38px !important;
    display: flex!important;
    align-items: center!important
  }

  .select-category > .theme--light.v-text-field--solo > .v-input__control > .v-input__slot {
    border-radius: 6px;
  }
}
</style>